import template from '../unit.popup/unit.popup.html';
import { UnitPopupCtrl } from './UnitPopupCtrl';

unitPopupRoutesConfig.$inject = ['$stateProvider'];

export function unitPopupRoutesConfig($stateProvider) {
  $stateProvider
    .state('unitpopup', {
      url: '/unitpopup',
      template: '<ui-view/>',
    })
    .state('unitpopup.view', {
      url: '/view/:id',
      controller: UnitPopupCtrl,
      controllerAs: 'vm',
      template,
    });
}
